// extracted by css-extract-rspack-plugin
export default {"Box":"SubIssuesList-module__Box__XF6HD","ButtonGroup":"SubIssuesList-module__ButtonGroup__zJr5c"};